import React from 'react';

import { InputLabel } from '@material-ui/core';
import { DriverOption, DriverSingleValue } from 'components/ObjectiveTagList/ReactSelectCompOverrides';
import Select from 'react-select';
import styled from 'styled-components';

import { OBJECTIVE_LEVEL_TAGS } from 'constants/ProjectConstants';

import { Typography12 } from 'uiToolkit/Typography';

import { useObjectiveSidepanel } from '../context/ObjectiveSidePanelContext';

const ObjectiveLevel = () => {
  const { state, setObjectiveLevel } = useObjectiveSidepanel();
  const { objectiveLevel } = state;
  return (
    <InputLabel htmlFor="objective-level-field">
      <Typography12 bottomGutter={1}>Level*</Typography12>
      <StyledSelectDropdown
        menuShouldScrollIntoView={false}
        options={OBJECTIVE_LEVEL_TAGS}
        onChange={(v) => setObjectiveLevel(v.value)}
        value={OBJECTIVE_LEVEL_TAGS.filter((opt) => opt.value === objectiveLevel)[0]}
        classNamePrefix="driver-select"
        placeholder="Select Type"
        components={{ Option: DriverOption, SingleValue: DriverSingleValue }}
      />
    </InputLabel>
  );
};

const StyledSelectDropdown = styled(Select)`
  & > .driver-select__control {
    height: 40px;
  }
`;

export default ObjectiveLevel;
